export const siteName = '忍界攻略录';
export const siteSlogan = '把每条故事线都玩透';
export const siteDesc = '面向剧情党的火影同人RPG游戏攻略站，收录隐藏剧情触发条件、多结局走向与角色扮演体验。';

export interface GameItem {
  id: string;
  title: string;
  tagline: string;
  category: string;
  cover: string;
  rating: number;
  playtime: string;
  routeCount: number;
  endingCount: number;
  tags: string[];
  desc: string;
  hidden: string;
}

export const categories = ['全部', '剧情向', '角色扮演', '多结局', '高自由'];

export const games: GameItem[] = [
  {
    id: 'shadow-uchiha',
    title: '《忍界暗影：宇智波篇》',
    tagline: '在忠诚与复仇之间，重新选择写轮眼的归宿',
    category: '剧情向',
    cover: 'https://narutsur.github.io/api/search-image?query=Stylized%20anime%20game%20key%20art%20of%20a%20young%20ninja%20in%20dark%20high-collar%20cloak%20unleashing%20a%20swirl%20of%20crimson%20chakra%20fire%20in%20a%20night%20rain%2C%20ink%20brush%20style%20with%20warm%20ember%20and%20deep%20red%20accents%20on%20near-black%20background%2C%20dynamic%20pose%2C%20dramatic%20rim%20lighting%2C%20high%20detail%20painterly%20composition&width=640&height=860&seq=cover-uchiha-01&orientation=portrait',
    rating: 9.4,
    playtime: '约 25 小时',
    routeCount: 6,
    endingCount: 4,
    tags: ['宇智波', '复仇线', '宿命'],
    desc: '以宇智波一族视角展开的剧情向RPG，玩家将在木叶与叛逃之间做出抉择，角色的每一句对白都会影响同伴的信任值。',
    hidden: '第三章雨夜对话中连续选择「沉默」两次，可解锁隐藏记忆碎片，揭示灭族之夜的另一重真相。',
  },
  {
    id: 'will-of-fire',
    title: '《火之意志：第七班再集结》',
    tagline: '重写第七班羁绊，命运从此分岔',
    category: '角色扮演',
    cover: 'https://narutsur.github.io/api/search-image?query=Stylized%20anime%20game%20art%20of%20three%20young%20genin%20standing%20back%20to%20back%20on%20a%20windy%20hill%20under%20an%20orange%20dusk%20sky%2C%20ink%20brush%20style%2C%20warm%20amber%20and%20teal%20accents%20on%20ink%20background%2C%20dynamic%20triangular%20composition%2C%20cinematic%20painterly%20rendering&width=640&height=860&seq=cover-team7-02&orientation=portrait',
    rating: 9.1,
    playtime: '约 30 小时',
    routeCount: 8,
    endingCount: 5,
    tags: ['第七班', '羁绊', '成长'],
    desc: '扮演第七班的一员重新经历中忍考试，通过任务与对话积累羁绊，最终揭开贯穿全作的伏笔。',
    hidden: '忍界大战前夜，若三人羁绊值均满，可触发「最后的拉面」隐藏事件，影响真结局走向。',
  },
  {
    id: 'wind-rouge',
    title: '《风影残卷：沙之盟约》',
    tagline: '大漠孤城之下，藏着被抹去的一页',
    category: '多结局',
    cover: 'https://narutsur.github.io/api/search-image?query=Stylized%20anime%20game%20art%20of%20a%20sand%20ninja%20with%20floating%20sand%20shards%20standing%20before%20a%20giant%20golden%20sun%20over%20desert%20dunes%2C%20ink%20brush%20style%2C%20warm%20sand%20gold%20and%20crimson%20palette%20on%20deep%20background%2C%20epic%20silhouette%2C%20painterly%20high%20detail&width=640&height=860&seq=cover-suna-03&orientation=portrait',
    rating: 8.8,
    playtime: '约 22 小时',
    routeCount: 9,
    endingCount: 6,
    tags: ['砂隐', '盟约', '抉择'],
    desc: '围绕砂隐村与木叶的盟约展开，玩家的每次外交决策都牵动两国存亡，是名副其实的多结局作品。',
    hidden: '第四夜在城墙上将「旧信物」交给流浪商贩，可进入被删除的「雨之国线」支线。',
  },
  {
    id: 'kyubi-lullaby',
    title: '《尾兽摇篮曲》',
    tagline: '少年与九尾的约定，足以逆转终末',
    category: '剧情向',
    cover: 'https://narutsur.github.io/api/search-image?query=Stylized%20anime%20game%20art%20of%20a%20boy%20silhouette%20facing%20a%20huge%20glowing%20orange%20fox%20spirit%20made%20of%20swirling%20chakra%20flames%2C%20ink%20brush%20style%2C%20warm%20orange%20and%20gold%20palette%20on%20midnight%20background%2C%20emotional%20epic%20composition%2C%20painterly%20detail&width=640&height=860&seq=cover-kyubi-04&orientation=portrait',
    rating: 9.0,
    playtime: '约 18 小时',
    routeCount: 5,
    endingCount: 3,
    tags: ['人柱力', '和解', '终末'],
    desc: '以人柱力的内心世界为主线，探索少年与尾兽从对立到和解的漫长旅程，情感刻画细腻。',
    hidden: '在「内心世界」地图第七次返回起点并选择倾听，可解锁尾兽的旧日记忆结局。',
  },
  {
    id: 'red-moon-prison',
    title: '《赤月之牢》',
    tagline: '越狱即入局，每一道锁链都通向不同真相',
    category: '高自由',
    cover: 'https://narutsur.github.io/api/search-image?query=Stylized%20anime%20game%20art%20of%20a%20hooded%20ninja%20breaking%20iron%20chains%20with%20crimson%20chakra%20light%20in%20a%20stone%20prison%2C%20ink%20brush%20style%2C%20red%20moon%20in%20background%2C%20dark%20crimson%20and%20amber%20palette%2C%20intense%20moody%20composition%2C%20painterly&width=640&height=860&seq=cover-prison-05&orientation=portrait',
    rating: 8.6,
    playtime: '约 20 小时',
    routeCount: 7,
    endingCount: 5,
    tags: ['越狱', '自由线', '揭秘'],
    desc: '开放度极高的角色扮演作，玩家可自由选择越狱方式、结盟对象与背叛时机，进程完全由选择驱动。',
    hidden: '选择「不揭发同伴」并在同一地点重复蹲守三夜，可发现牢底密道与隐藏真相。',
  },
  {
    id: 'dawn-of-leaves',
    title: '《叶之黎明》',
    tagline: '在战争前夕，守护最平凡的日常',
    category: '角色扮演',
    cover: 'https://narutsur.github.io/api/search-image?query=Stylized%20anime%20game%20art%20of%20villagers%20and%20ninja%20sharing%20a%20warm%20meal%20around%20a%20lantern-lit%20stall%20at%20dusk%20in%20a%20leaf%20village%2C%20ink%20brush%20style%2C%20warm%20amber%20and%20cream%20palette%20on%20gentle%20ink%20background%2C%20slice%20of%20life%2C%20cozy%20painterly%20detail&width=640&height=860&seq=cover-dawn-06&orientation=portrait',
    rating: 8.9,
    playtime: '约 16 小时',
    routeCount: 4,
    endingCount: 3,
    tags: ['日常', '守护', '治愈'],
    desc: '聚焦战争前夜的平凡日常，通过经营与陪伴积累情感，结局温柔而有力。',
    hidden: '把「便当」送给不同村民满十次，可触发隐藏的「全村感谢」纪念事件。',
  },
];

export const hiddenStories = [
  {
    id: 'h1',
    title: '被抹去的雨之国线',
    game: '《风影残卷：沙之盟约》',
    tag: '隐藏支线',
    trigger: '第四夜城墙上将旧信物交给流浪商贩',
    desc: '这条被开发者隐藏的支线讲述被两国盟约刻意遗忘的雨之国往事。完成三次信物交易后，地图会解锁一段只存在于回忆中的边境小镇。',
  },
  {
    id: 'h2',
    title: '灭族之夜的第三重真相',
    game: '《忍界暗影：宇智波篇》',
    tag: '记忆碎片',
    trigger: '第三章雨夜对话连续选择两次「沉默」',
    desc: '当角色选择沉默而非辩解时，一段尘封的记忆被唤醒。这段隐藏回忆将推翻主线给出的表面解释，让复仇线的动机变得复杂而真实。',
  },
  {
    id: 'h3',
    title: '尾兽的旧日记忆',
    game: '《尾兽摇篮曲》',
    tag: '隐藏结局',
    trigger: '内心世界第七次返回起点并选择倾听',
    desc: '看似重复的内心世界，实则藏着一套「轮回计数」机制。第七次返回时选择倾听，会揭开尾兽被封印前的完整故事，通往被标记为不可见的结局。',
  },
  {
    id: 'h4',
    title: '牢底密道与真相',
    game: '《赤月之牢》',
    tag: '秘密地点',
    trigger: '不揭发同伴并连续蹲守三夜',
    desc: '高自由度作品里的信任本身就是谜题。选择守护同伴的代价，是在同一地点等待三个夜晚，最终发现监狱地下的密道与隐藏真相。',
  },
];

export const endingRoutes = [
  {
    id: 'e1',
    type: '真结局',
    icon: 'ri-sun-line',
    title: '「黎明与羁绊」',
    game: '《叶之黎明》',
    cond: '羁绊值全满 + 便当馈赠十次 + 战争前夜触发「最后的晚餐」',
    desc: '唯一需要同时满足数值与事件双重条件的结局。在战火降临前，全村人围绕同一张桌子，把守护最平凡日常的意志传递下去。',
    tips: '别急着推进主线，日常事件的比例直接决定该结局能否触发。',
  },
  {
    id: 'e2',
    type: '好结局',
    icon: 'ri-heart-3-line',
    title: '「归还之刃」',
    game: '《忍界暗影：宇智波篇》',
    cond: '信任值 ≥ 80 且未在终局背叛同伴',
    desc: '将复仇执念转化为守护的力量，刃归鞘，人归乡。需要在中后期多次放弃「最有利」的战斗选择以维持信任。',
    tips: '终局前的「背叛诱惑」选项是隐藏减分项，切勿触碰。',
  },
  {
    id: 'e3',
    type: '隐藏结局',
    icon: 'ri-moon-foggy-line',
    title: '「沙下之城」',
    game: '《风影残卷：沙之盟约》',
    cond: '完成雨之国支线 + 拒绝公开盟约',
    desc: '在被抹去的支线里收集全部信物后，拒绝官方的和平剧本，独自走向被黄沙掩埋的旧城，揭晓盟约背后的交易。',
    tips: '需要在「拒绝」选项出现前就已完成三次信物交易，错过无法补救。',
  },
  {
    id: 'e4',
    type: '普通结局',
    icon: 'ri-road-map-line',
    title: '「各自的道路」',
    game: '《火之意志：第七班再集结》',
    cond: '羁绊值中等，未满足任何特殊条件',
    desc: '伙伴们带着各自的成长走向不同方向。作为默认结局，它平和而完整，适合第一次通关的玩家自然抵达。',
    tips: '这是了解世界观的最佳起点，二周目再追求隐藏内容。',
  },
  {
    id: 'e5',
    type: '坏结局',
    icon: 'ri-sword-line',
    title: '「赤月孤影」',
    game: '《赤月之牢》',
    cond: '背叛同伴或触发三次以上冲突',
    desc: '越狱成功的代价是众叛亲离。赤月之下只剩孤身一人，所有盟友都成了背景里的冷眼。',
    tips: '该结局有专属成就，剧情党建议刻意打一次收藏。',
  },
];

export const testimonials = [
  {
    id: 't1',
    name: '一叶知秋',
    role: '多周目玩家',
    text: '攻略把隐藏触发条件写得很清楚，尤其是「轮回计数」那类机制，之前真的怎么都找不到。照着走完每条故事线，感觉像重新玩了三遍。',
  },
  {
    id: 't2',
    name: '木叶丸的橡皮擦',
    role: '剧情收集党',
    text: '最喜欢结局攻略的分类方式，真结局、隐藏、普通、坏结局一眼就能看懂，还会提醒哪些选项是隐藏减分项，太贴心了。',
  },
  {
    id: 't3',
    name: '半藏',
    role: 'RPG 老玩家',
    text: '内容有深度也有温度，不是机械堆砌的流水账，是真的站在剧情党角度写的。问几个问题，回复快，说得也明白。',
  },
];

export const faqs = [
  {
    id: 'f1',
    q: '什么是剧情向火影同人RPG游戏？',
    a: '剧情向火影同人RPG以角色扮演和叙事为核心，玩家的每一个选择都会改变剧情走向与同伴关系，最终通往不同结局。它更强调故事体验，而不是单纯的战斗数值堆砌。',
  },
  {
    id: 'f2',
    q: '隐藏剧情一般怎么触发？',
    a: '常见触发方式包括：特定时间地点重复互动、连续选择某些看似中性的对白、在关键节点放弃「最优」选项、以及完成特定道具的多次馈赠。多数隐藏内容需要二周目才能完整解锁。',
  },
  {
    id: 'f3',
    q: '多结局作品是否需要重复游玩？',
    a: '是的。多结局作品通常围绕「信任值」「羁绊值」等隐藏数值设计，不同路线会呈现互补的世界观。建议第一周目自然通关体验主线，第二周目再按攻略追求隐藏内容。',
  },
  {
    id: 'f4',
    q: '攻略会剧透主线吗？',
    a: '我们严格区分「主线指引」和「剧情详解」。追求隐藏内容的攻略会明确标注剧透提示，首次游玩的玩家可以只看触发条件，不影响原汁原味的体验。',
  },
  {
    id: 'f5',
    q: '隐藏结局一定要重开存档吗？',
    a: '多数作品提供章节选择功能，可在关键节点回跳。少数真结局因涉及全局数值，需要重开。我们的攻略会明确标注每个结局是否需要新周目。',
  },
];